import { LoadingSkeleton, PageGridContainer, PageGridItem } from 'ComponentLibrary'
import { Stack } from '@mui/material'

export const AssetKeyValuesLoader = () => {
    return (
        <PageGridContainer>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <Stack direction="row" justifyContent="flex-end">
                    <LoadingSkeleton height="20px" width="365px" variant="rounded" />
                </Stack>
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <LoadingSkeleton height="267px" variant="rounded" />
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <LoadingSkeleton height="267px" variant="rounded" />
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <LoadingSkeleton height="267px" variant="rounded" />
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <LoadingSkeleton height="267px" variant="rounded" />
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <LoadingSkeleton height="510px" variant="rounded" />
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={4}>
                <LoadingSkeleton height="510px" variant="rounded" />
            </PageGridItem>
        </PageGridContainer>
    )
}
